export function collapse(element) {
  const sectionHeight = element.scrollHeight;

  const elementTransition = element.style.transition;
  element.style.transition = "";

  requestAnimationFrame(function () {
    element.style.height = sectionHeight + "px";
    element.style.transition = elementTransition;

    requestAnimationFrame(function () {
      element.style.height = 0 + "px";
    });
  });
}

export function expand(element) {
  const sectionHeight = element.scrollHeight;

  element.style.height = sectionHeight + "px";

  element.addEventListener("transitionend", function resetHeight(e) {
    element.removeEventListener("transitionend", resetHeight);
    element.style.height = null;
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".scrolltobtn");

  if (buttons.length === 0) {
    return;
  }

  const header = document.querySelector("header");
  const headerHeight = header ? header.offsetHeight : 0;

  buttons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      const targetId = this.getAttribute("href");
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const elementPosition =
          targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
    const backButton = document.querySelector('.hero_catalog__goback');

    if (backButton) {
        backButton.addEventListener('click', function (e) {
            e.preventDefault(); // на случай, если это ссылка или форма

            if (window.history.length > 1) {
                window.history.back();
            } else {
                // Если в истории ничего нет — перенаправляем на главную
                window.location.href = '/'; // или свой URL
            }
        });
    }
});